import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends, typeof as _typeof, objectDestructuringEmpty as _objectDestructuringEmpty } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { css } from 'styled-components';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import React, { memo, useState, useEffect, useCallback } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import _Box from '../Box/index.js';
import _Icon from '../Icon/index.js';
import _Heading from '../Heading/index.js';
import _Checkbox from '../Checkbox/index.js';

var _excluded = ["checked", "checkboxField", "collapsedIcon", "depth", "expandedIcon", "isOpen", "textColor", "theme", "title", "titleComponent", "handleChange", "handleHeaderClick", "hasChildren", "headerLeftDisplay", "headerRightDisplay", "type", "headerElemType", "headerElemStyle", "style", "child"],
  _excluded2 = ["bodyBackgroundColor", "bodyClassName", "color", "checked", "checkboxField", "children", "checkboxChange", "collapsedIcon", "expandedIcon", "headerClick", "headerLeftDisplay", "headerRightDisplay", "isOpen", "noBorder", "textColor", "theme", "title", "titleComponent", "type", "headerElemType", "headerElemStyle", "getControl", "isOpenRef", "child"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;
var CollapseContext = /*#__PURE__*/React.createContext(0);
var getIcon = function getIcon(isOpen, type) {
  if (type === 'alternate') {
    return isOpen ? 'subtract' : 'add';
  } else {
    return isOpen ? 'chevron-down-solid' : 'chevron-right-solid';
  }
};
var StyledWrapper = styled('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  text-align: left;\n  ", "\n  ", "\n"])), function (_ref) {
  var type = _ref.type;
  return type === 'folder' && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      margin-top: 0;\n    "])));
}, function (_ref2) {
  var type = _ref2.type;
  return (type === 'default' || type === 'alternate') && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      padding: 0.5rem;\n    "])));
});
var StyledTitleWrapper = styled('div')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  padding-left: ", ";\n"])), function (_ref3) {
  var type = _ref3.type;
  return type !== 'box' && type !== 'alternate' && css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      border-bottom: 1px solid\n        ", ";\n      padding-bottom: 0.75rem;\n    "])), function (_ref4) {
    var palette = _ref4.theme.palette;
    return palette.grayLighter;
  });
}, function (_ref5) {
  var type = _ref5.type;
  return type === 'folder' && css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      font-size: 1rem;\n      font-weight: normal;\n      padding: 0.75rem 0.75rem 0.75rem 0;\n      &:hover {\n        background: ", ";\n      }\n      border-bottom: ", ";\n    "])), function (_ref6) {
    var palette = _ref6.theme.palette;
    return palette.grayLightest;
  }, function (_ref7) {
    var theme = _ref7.theme,
      child = _ref7.child;
    return child && theme === themes.secureSite ? 'none' : "1px solid ".concat(theme.palette.grayLighter);
  });
}, function (_ref8) {
  var depth = _ref8.depth,
    type = _ref8.type;
  return type === 'folder' ? "".concat(depth, "rem") : '0';
});
var StyledButton = styled('button')(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", " & {\n    all: inherit;\n    font-size: 1.133rem;\n    font-weight: normal;\n    color: inherit;\n    background: transparent;\n    border: none;\n    display: flex;\n    flex: 1;\n    text-align: left;\n    width: 100%;\n    font-family: ", ";\n    &:hover {\n      cursor: pointer;\n    }\n    &:focus {\n      text-decoration: underline;\n    }\n    @media (max-width: 576px) {\n      font-size: 1.0625rem;\n    }\n    ", "\n  }\n"])), function (_ref9) {
  var headerElemType = _ref9.headerElemType,
    theme = _ref9.theme;
  return headerElemType;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontFamily;
}, function (_ref11) {
  var displayType = _ref11.displayType;
  return displayType === 'folder' && css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n        font-size: 1rem;\n        font-weight: normal;\n      "])));
});
var StyledIcon = styled(_Icon)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  align-self: center;\n  margin-right: 0.5rem;\n  margin-left: 0;\n"])));
var StyledBodyBox = styled(_Box)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  border-top: ", ";\n"])), function (_ref12) {
  var noBorder = _ref12.noBorder;
  return noBorder && 'none';
});
var BoxOrNoBox = function BoxOrNoBox(_ref13) {
  var children = _ref13.children,
    color = _ref13.color,
    isOpen = _ref13.isOpen,
    type = _ref13.type,
    textColor = _ref13.textColor,
    theme = _ref13.theme;
  if (type === 'box') {
    return /*#__PURE__*/React.createElement(_Box, {
      theme: theme,
      color: color || 'grayLightest',
      textColor: textColor,
      type: !isOpen ? type : 'header'
    }, children);
  } else {
    return children;
  }
};
var HeaderChildren = function HeaderChildren(_ref14) {
  var checked = _ref14.checked,
    checkboxField = _ref14.checkboxField,
    CollapsedIcon = _ref14.collapsedIcon,
    depth = _ref14.depth,
    ExpandedIcon = _ref14.expandedIcon,
    isOpen = _ref14.isOpen,
    textColor = _ref14.textColor,
    theme = _ref14.theme,
    title = _ref14.title,
    TitleComponent = _ref14.titleComponent,
    handleChange = _ref14.handleChange,
    handleHeaderClick = _ref14.handleHeaderClick,
    hasChildren = _ref14.hasChildren,
    HeaderLeftDisplay = _ref14.headerLeftDisplay,
    HeaderRightDisplay = _ref14.headerRightDisplay,
    type = _ref14.type,
    headerElemType = _ref14.headerElemType,
    headerElemStyle = _ref14.headerElemStyle,
    style = _ref14.style,
    child = _ref14.child,
    rest = _objectWithoutProperties(_ref14, _excluded);
  var ariaTitle = title.replace(/\s/g, '-');
  // Default text color to black unless otherwise defined
  var headingColor = textColor ? textColor : 'black';
  if (!textColor && (type === 'alternate' || type === 'box')) {
    // Box and alternate use colored text. use these defaults if no color given
    headingColor = 'secondaryDark';
  }
  var ExpandCollapseIcon = function ExpandCollapseIcon(_ref15) {
    _objectDestructuringEmpty(_ref15);
    if (isOpen && ExpandedIcon) {
      return /*#__PURE__*/React.createElement(ExpandedIcon, null);
    } else if (!isOpen && CollapsedIcon) {
      return /*#__PURE__*/React.createElement(CollapsedIcon, null);
    }
    return /*#__PURE__*/React.createElement(StyledIcon, {
      name: getIcon(isOpen, type),
      size: 'xs',
      theme: theme,
      color: textColor ? textColor : 'secondaryDark'
    });
  };
  var isLFGFolder = type === 'folder' && theme === themes.secureSite;
  return /*#__PURE__*/React.createElement(StyledTitleWrapper, {
    depth: depth,
    theme: theme,
    type: type,
    style: style,
    child: child
  }, /*#__PURE__*/React.createElement(_Heading, {
    color: type === 'folder' && theme === themes.secureSite ? 'secondaryDark' : headingColor,
    elemType: headerElemType,
    elemStyle: headerElemStyle,
    style: {
      display: 'flex',
      marginTop: "".concat(type === 'folder' ? '0' : null)
    },
    theme: theme
  }, !!HeaderLeftDisplay && /*#__PURE__*/React.createElement(HeaderLeftDisplay, null), type === 'folder' && checkboxField && /*#__PURE__*/React.createElement(_Checkbox, {
    id: "test",
    initialValue: checked,
    field: checkboxField,
    label: checkboxField,
    hideLabel: true,
    onValueChange: handleChange,
    theme: theme
  }), /*#__PURE__*/React.createElement(StyledButton, _extends({
    "aria-expanded": isOpen
  }, isOpen ? {
    'aria-describedby': "".concat(ariaTitle, "-content")
  } : {}, {
    onClick: handleHeaderClick,
    theme: theme,
    displayType: type,
    type: "button",
    "aria-controls": "".concat(ariaTitle, "-content"),
    id: "".concat(ariaTitle, "-button")
  }, rest), hasChildren && !isLFGFolder && /*#__PURE__*/React.createElement(ExpandCollapseIcon, {
    isOpen: isOpen,
    type: type,
    theme: theme,
    color: textColor,
    ExpandedIcon: ExpandedIcon,
    CollapsedIcon: CollapsedIcon
  }), type === 'folder' && /*#__PURE__*/React.createElement(StyledIcon, {
    checkboxField: checkboxField,
    name: !isOpen ? 'folder-solid' : 'folder-open-solid',
    type: type,
    size: theme === themes.secureSite ? 'xs' : 'small',
    color: theme === themes.secureSite ? 'secondaryDark' : undefined,
    style: {
      marginTop: 0,
      marginBottom: 'auto'
    }
  }), /*#__PURE__*/React.createElement("div", null, TitleComponent ? /*#__PURE__*/React.createElement(TitleComponent, null) : title), hasChildren && type === 'folder' && theme === themes.secureSite && /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: '0.5rem'
    }
  }, /*#__PURE__*/React.createElement(ExpandCollapseIcon, {
    isOpen: isOpen,
    type: type,
    theme: theme,
    ExpandedIcon: ExpandedIcon,
    CollapsedIcon: CollapsedIcon,
    style: {
      marginLeft: '0.5rem'
    }
  }))), !!HeaderRightDisplay && (_typeof(HeaderRightDisplay) === 'object' ? HeaderRightDisplay : /*#__PURE__*/React.createElement(HeaderRightDisplay, null))));
};
var BodyChildren = function BodyChildren(_ref16) {
  var children = _ref16.children,
    isOpen = _ref16.isOpen,
    type = _ref16.type,
    title = _ref16.title;
  var ariaTitle = title.replace(/\s/g, '-');
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    hidden: !isOpen,
    type: type,
    id: "".concat(ariaTitle, "-content")
  }, children);
};
var Collapse = function Collapse(_ref17) {
  var _ref17$bodyBackground = _ref17.bodyBackgroundColor,
    bodyBackgroundColor = _ref17$bodyBackground === void 0 ? 'white' : _ref17$bodyBackground,
    bodyClassName = _ref17.bodyClassName,
    color = _ref17.color,
    checked = _ref17.checked,
    checkboxField = _ref17.checkboxField,
    children = _ref17.children,
    checkboxChange = _ref17.checkboxChange,
    collapsedIcon = _ref17.collapsedIcon,
    expandedIcon = _ref17.expandedIcon,
    headerClick = _ref17.headerClick,
    headerLeftDisplay = _ref17.headerLeftDisplay,
    headerRightDisplay = _ref17.headerRightDisplay,
    isOpenProp = _ref17.isOpen,
    noBorder = _ref17.noBorder,
    _ref17$textColor = _ref17.textColor,
    textColor = _ref17$textColor === void 0 ? 'secondaryDark' : _ref17$textColor,
    _ref17$theme = _ref17.theme,
    theme = _ref17$theme === void 0 ? themes["default"] : _ref17$theme,
    _ref17$title = _ref17.title,
    title = _ref17$title === void 0 ? 'Section Accordion' : _ref17$title,
    titleComponent = _ref17.titleComponent,
    _ref17$type = _ref17.type,
    type = _ref17$type === void 0 ? 'default' : _ref17$type,
    _ref17$headerElemType = _ref17.headerElemType,
    headerElemType = _ref17$headerElemType === void 0 ? 'h4' : _ref17$headerElemType,
    headerElemStyle = _ref17.headerElemStyle,
    _ref17$getControl = _ref17.getControl,
    getControl = _ref17$getControl === void 0 ? function () {} : _ref17$getControl,
    _ref17$isOpenRef = _ref17.isOpenRef,
    isOpenRef = _ref17$isOpenRef === void 0 ? function () {} : _ref17$isOpenRef,
    _ref17$child = _ref17.child,
    child = _ref17$child === void 0 ? false : _ref17$child,
    rest = _objectWithoutProperties(_ref17, _excluded2);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  useEffect(function () {
    if (isOpenProp !== undefined) {
      setIsOpen(isOpenProp);
    }
  }, [isOpenProp]);
  useEffect(function () {
    getControl(setIsOpen);
  }, [setIsOpen]);
  var handleHeaderClick = useCallback(function (e) {
    if (headerClick) {
      headerClick(e);
    }
    setIsOpen(function (currIsOpen) {
      return !currIsOpen;
    });
  }, [setIsOpen]);
  useEffect(function () {
    isOpenRef(isOpen);
  }, [isOpen]);
  return /*#__PURE__*/React.createElement(CollapseContext.Consumer, null, function (depth) {
    // TODO: figure out a similar strategy to display non-collapse elements with the nested margin in the Directory composite component.
    // currently this only affects Collapse elements (subdirectories) but we may eventually want to display complete file trees. Currently
    // as far as I can tell, there are no features in the portal using the Directory components that aren't hiding the files so not a concern at the moment.
    var hasChildren = !!React.Children.count(children);
    var additionToMargin = 0.5;
    if (theme === themes.secureSite && type === 'folder') {
      if (depth !== 0) {
        additionToMargin = 2;
      }
    }
    return /*#__PURE__*/React.createElement(CollapseContext.Provider, {
      value: depth + additionToMargin
    }, /*#__PURE__*/React.createElement(BoxOrNoBox, {
      theme: theme,
      color: color,
      isOpen: isOpen,
      type: type
    }, /*#__PURE__*/React.createElement(HeaderChildren, _extends({
      checkboxField: checkboxField,
      checked: checked,
      collapsedIcon: collapsedIcon,
      depth: depth + additionToMargin,
      expandedIcon: expandedIcon,
      handleChange: checkboxChange,
      handleHeaderClick: handleHeaderClick,
      hasChildren: hasChildren,
      headerElemType: headerElemType,
      headerElemStyle: headerElemStyle ? headerElemStyle : headerElemType,
      headerRightDisplay: headerRightDisplay,
      headerLeftDisplay: headerLeftDisplay,
      isOpen: isOpen,
      textColor: textColor,
      theme: theme,
      title: title,
      titleComponent: titleComponent,
      type: type,
      child: child
    }, rest))), type === 'box' ? /*#__PURE__*/React.createElement(StyledBodyBox, {
      theme: theme,
      className: bodyClassName,
      color: bodyBackgroundColor,
      hidden: !isOpen,
      noBorder: noBorder
    }, /*#__PURE__*/React.createElement(BodyChildren, {
      children: children,
      isOpen: isOpen,
      type: type,
      title: title
    })) : /*#__PURE__*/React.createElement(BodyChildren, {
      children: children,
      isOpen: isOpen,
      type: type,
      title: title
    }));
  });
};
var _Collapse = withDefaultTheme(/*#__PURE__*/memo(Collapse));

export default _Collapse;
